var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 134,
    viewBox: "0 0 141 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_1384)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3754 57.4342C13.3754 32.5565 34.6226 12.3891 60.8323 12.3891C87.042 12.3891 108.289 32.5565 108.289 57.4342C108.289 82.3119 87.042 102.479 60.8323 102.479C34.6226 102.479 13.3754 82.3119 13.3754 57.4342ZM60.8323 0.535156C27.7252 0.535156 0.886719 26.0097 0.886719 57.4342C0.886719 88.8587 27.7252 114.333 60.8323 114.333C72.8674 114.333 84.0741 110.967 93.4643 105.172L119.441 129.829C124.318 134.457 132.225 134.457 137.103 129.829C141.98 125.199 141.98 117.693 137.103 113.064L111.126 88.4078C117.231 79.4949 120.778 68.8577 120.778 57.4342C120.778 26.0097 93.9393 0.535156 60.8323 0.535156Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_1384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139.873,
    height: 132.764,
    fill: "white",
    transform: "translate(0.886719 0.535156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.d9850aaf814014d35ca377b2236bc8b1.svg";
export { ForwardRef as ReactComponent };